// extracted by mini-css-extract-plugin
export default {"root":"mask-iban_root__lSxR+","value":"mask-iban_value__wLgOj","valueText":"mask-iban_valueText__KrXdM","actions":"mask-iban_actions__BRzEL"};